<template><!-- svgo-optimised -->
<svg class="icon icon__minus icon icon__minus" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M14 8a.5.5 0 0 1-.5.5h-11a.5.5 0 1 1 0-1h11a.5.5 0 0 1 .5.5Z"/></svg>
</template>